import React, { Suspense, lazy } from 'react';
import './App.css';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Landing from './pages/Landing';
import {
  isPartnersSubdomainHost,
  isCrmAllowedHost,
  shouldRedirectCrmPath,
} from './utils/subdomainGuard';

// Code Splitting: Lazy-load Admin panel, ThankYou & Partners CRM to eliminate unused JS on landing page
const Admin = lazy(() => import('./pages/Admin'));
const ThankYou = lazy(() => import('./pages/ThankYou'));
const PartnersCRM = lazy(() => import('./pages/PartnersCRM'));

function App() {
  const hostname =
    typeof window !== 'undefined' ? window.location.hostname : '';
  const pathname =
    typeof window !== 'undefined' ? window.location.pathname : '';

  const isPartnersSubdomain = isPartnersSubdomainHost(hostname);
  const isCrmAllowed = isCrmAllowedHost(hostname);

  // On main domain, immediately redirect any pathname-based /partners or /crm access to root
  if (typeof window !== 'undefined' && shouldRedirectCrmPath(hostname, pathname)) {
    window.location.replace('/');
  }

  return (
    <div className="App">
      <Router>
        <Suspense fallback={null}>
          <Routes>
            {/* On partners subdomain, root renders PartnersCRM. On main domain, root renders Landing */}
            <Route path="/" element={isPartnersSubdomain ? <PartnersCRM /> : <Landing />} />

            {/* If CRM is allowed (partners subdomain or local dev), route to PartnersCRM.
                On main domain (gastrobloggersday.com / www), redirect immediately to root */}
            <Route
              path="/partners"
              element={isCrmAllowed ? <PartnersCRM /> : <Navigate to="/" replace />}
            />
            <Route
              path="/partners/*"
              element={isCrmAllowed ? <PartnersCRM /> : <Navigate to="/" replace />}
            />
            <Route
              path="/crm"
              element={isCrmAllowed ? <PartnersCRM /> : <Navigate to="/" replace />}
            />
            <Route
              path="/crm/*"
              element={isCrmAllowed ? <PartnersCRM /> : <Navigate to="/" replace />}
            />

            {!isPartnersSubdomain && (
              <>
                <Route path="/admin" element={<Admin />} />
                <Route path="/thankyou" element={<ThankYou />} />
                <Route path="/thankYou" element={<ThankYou />} />
                <Route path="/ThankYou" element={<ThankYou />} />
                <Route path="/thank-you" element={<ThankYou />} />
                <Route path="/Thank-You" element={<ThankYou />} />
                <Route path="/success" element={<ThankYou />} />
              </>
            )}

            {/* Fallback routing */}
            {isPartnersSubdomain ? (
              <Route path="*" element={<PartnersCRM />} />
            ) : (
              <Route path="*" element={<Navigate to="/" replace />} />
            )}
          </Routes>
        </Suspense>
      </Router>
    </div>
  );
}

export default App;
